module.exports = __webpack_public_path__ + "img/arc.5424d80b.jpg";